import React, {Spinner} from "react-bootstrap";

export const Loading = ({size = 'sm'}) => <div className="w-100 text-center py-1">
    <Spinner size={size} className="text-light my-auto mx-auto" animation="border"/>
</div>;